import { Component, Input } from '@angular/core';
import { BaseListComponent } from 'app/base';
import { Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { Sistema } from 'app/entity/sistema.model';
import { Tabela } from 'app/entity/tabela.model';
import { TrilhaDeAuditoriaTabela } from 'app/entity/trilha_de_auditoria_tabela.model';
import * as FileSaver from 'file-saver';
import { SelectItem } from 'primeng/primeng';

@Component({
  selector: 'trilha-auditoria-relatorio',
  templateUrl: './trilha-auditoria-relatorio.component.html',
})
export class TrilhaAuditoriaRelatorioComponent extends BaseListComponent {
  @Input() listaSistema: Sistema[];
  @Input() listaStatus: any[];
  @Input() dadosAuditoria;
  displayExportar = false;
  id_sistema: number;
  emissao: Date;
  listaTabelas: SelectItem[] = [];
  tabelasSelecionadas: string[] = [];
  dataAtual = new Date();

  solicitacao = this.formBuilder.group({
    tabelas: TrilhaDeAuditoriaTabela,
    campos_nao_alterados: [null],
    operacao: [null, Validators.required],
    tipo_exportacao: [1, Validators.required],
  });

  filtro = this.formBuilder.group({
    possui: [null],
    id: [null],
    id_sistema: [null],
    id_perfil: [null],
    tipo: [null],
  });

  init() {
    const paramId = +this.activatedRoute.snapshot.paramMap.get('id');
    this.service.Obter('trilha-auditoria', paramId).subscribe((x) => {
      (this.id_sistema = x.id_sistema),
        this.filtro.get('id_sistema').patchValue(x.id_sistema);
      for (const tab of x.trilha_de_auditoria_tabela) {
        this.listaTabelas.push({ label: tab.nome_tabela, value: tab.nome_tabela });
      }
    });

    this.filtro.get('id').patchValue(paramId);
  }

  cancelar() {
    this.displayExportar = false;
  }

  exportar() {
    this.displayExportar = true;
  }

  confirmarExportar() {
    let envBackEnd = {
      id: this.filtro.get('id').value,
      id_sistema: this.filtro.get('id_sistema').value,
      tipo_exportacao: this.solicitacao.get('tipo_exportacao').value,
      tabelas: [],
    }

    for (const tab of this.tabelasSelecionadas) {
      envBackEnd.tabelas.push({ nome_tabela: tab });
    }

    if (envBackEnd.tabelas.length) {
      this.confirmacao.confirm({
        header: 'Mensagem de Confirmação',
        message: `Atenção! Deseja mesmo exportar o relário de Auditoria?`,
        accept: () => {
          this.observableUtilPanelDoc.setBlockedPanel(true);

          if (+envBackEnd.tipo_exportacao === 1) {
            this.exportarPdf('trilha-auditoria/exportar', envBackEnd,
              'TrilhaAuditoria.pdf', 'Auditoria foi impressa com sucesso.', 'Houve um erro ao imprimir a Auditoria');
          } else {
            this.exportarExcel('trilha-auditoria/exportar', envBackEnd,
              'TrilhaAuditoria.xlsx', 'Auditoria foi impressa com sucesso.', 'Houve um erro ao imprimir a Auditoria');
          }

          this.displayExportar = false;
        }
      });
    } else {
      this.showMsg('warn', 'Mensagem de Aviso', `Selecione pelo menos 1 tabela para exportar.`);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/trilha-auditoria/crud/etapas/trilha-auditoria-relatorio.component.ts